// extracted by mini-css-extract-plugin
module.exports = {"list":"MultiColumns_list__1zFub","default":"MultiColumns_default__eLBN1","column":"MultiColumns_column__2Zdtr"};